import React from 'react'

import './CharacterRelationStyles.less'

export default ({ parentCharacterName, relationText, className = '' }) => (
  <p className={`CharacterRelation ${className}`}>{relationText} для {parentCharacterName}</p>
)
